// セレンディピティ（未踏ジャンルから一冊）
import { escapeHtml, screenHead, showScreen, showLoading, hideLoading, toast, renderHistorySection, bindHistoryHandlers, renderBookFilter, getFilterState, applyBookFilter, bindFilterCounter } from '../ui.js';
import { fetchSerendipity } from '../api.js';
import { getAllBooks, saveAiHistory, getAiHistoryByType } from '../cache.js';

export async function showSerendipityScreen() {
  const books = await getAllBooks();
  if (books.length < 5) {
    showScreen('serendipity', `${screenHead('セレンディピティ')}<p class="empty">書籍が少なすぎます（${books.length} 冊）。5 冊以上 同期してからお試しください。</p>`);
    document.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
    return;
  }
  await renderPicker(books);
}

async function renderPicker(books) {
  const histItems = await getAiHistoryByType('serendipity');
  const html = `
    ${screenHead('セレンディピティ')}
    <p style="color:var(--dim);font-size:13px;line-height:1.75;margin:0 0 16px;">
      あなたがほぼ手を出していない領域から、AI が「あえて」一冊だけ推薦します。<br/>
      毎回違う盲点を投げてもらえます。
    </p>
    ${renderBookFilter()}
    <button class="btn btn--ink btn--block" id="btn-go" type="button">
      <svg class="icon"><use href="#i-compass"/></svg>
      <span>盲点の一冊を見せる</span>
    </button>
    ${renderHistorySection(histItems)}
  `;
  const screen = showScreen('serendipity', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
  bindFilterCounter(screen, books);
  screen.querySelector('#btn-go').addEventListener('click', async () => {
    showLoading('盲点を探索中…');
    try {
      const filtered = applyBookFilter(books, getFilterState(screen));
      const item = await fetchSerendipity(filtered.length ? filtered : books);
      await saveAiHistory({
        type: 'serendipity',
        title: item.title || '盲点の一冊',
        subtitle: item.author || item.blindSpot?.slice(0, 60),
        context: {},
        payload: item,
      });
      renderResult(item, books);
    } catch (e) {
      toast('生成に失敗しました');
    } finally {
      hideLoading();
    }
  });
  bindHistoryHandlers(
    screen,
    histItems,
    (entry) => renderResult(entry.payload, books),
    () => renderPicker(books)
  );
}

export async function renderFromHistory(entry) {
  const books = await getAllBooks();
  renderResult(entry.payload, books);
}

function renderResult(item, books) {
  const amazonUrl = `https://www.amazon.co.jp/s?k=${encodeURIComponent(item.title + ' ' + (item.author || ''))}`;
  const koshoUrl = `https://www.kosho.or.jp/products/list.php?search_word=${encodeURIComponent(item.title + ' ' + (item.author || ''))}`;
  const html = `
    ${screenHead('セレンディピティ')}
    <article class="result-card" style="padding:24px 20px;">
      <p style="margin:0 0 8px;font-family:var(--font-mono);font-size:10px;letter-spacing:0.22em;text-transform:uppercase;color:var(--mute);">your blind spot</p>
      <p style="margin:0 0 16px;font-size:13px;color:var(--dim);line-height:1.75;font-style:italic;">${escapeHtml(item.blindSpot || '')}</p>
      <h3 style="margin:0 0 4px;font-family:var(--font-serif);font-size:22px;font-weight:500;">${escapeHtml(item.title || '')}</h3>
      <p style="margin:0 0 16px;font-size:13px;color:var(--mute);">${escapeHtml(item.author || '')}${item.genre ? ' · ' + escapeHtml(item.genre) : ''}</p>
      <p class="result-card__body">${escapeHtml(item.reason || '')}</p>
      <div class="result-card__chips" style="margin-top:16px;">
        <a class="chip" href="${escapeHtml(amazonUrl)}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;">Amazon</a>
        <a class="chip" href="${escapeHtml(koshoUrl)}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;">日本の古本屋</a>
      </div>
    </article>
    <button class="btn btn--block btn--ghost" id="btn-regen" type="button" style="margin-top:24px;">
      <svg class="icon"><use href="#i-refresh"/></svg>
      <span>別の盲点を探す</span>
    </button>
  `;
  const screen = showScreen('serendipity-result', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
  screen.querySelector('#btn-regen').addEventListener('click', async () => {
    showLoading('別の盲点を探索中…');
    try {
      const fresh = await fetchSerendipity(books);
      renderResult(fresh, books);
    } catch (e) {
      toast('再生成に失敗しました');
    } finally {
      hideLoading();
    }
  });
}
